import React from "react"
import { useDispatch } from "react-redux";
import { Form, Formik } from "formik";
import { getBuyBackFeeFormInitialValues, VALIDATION_SCHEMA, } from "web/components/utils/vendotPricingModalUtils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import VendorPricingModal from "../PopUpModals/VendorPricingModal"

const AddMoreVendorsToCustomerForm = ({ closeAddModal, addMoreSelectedItem, vendorLocationList }) => {
  const history = useHistory()
  const dispatch = useDispatch()

  return (
    <>
      <Formik
        initialValues={getBuyBackFeeFormInitialValues()}
        validationSchema={VALIDATION_SCHEMA()}
      >
        {(formikProps) => {
          const { isValid, dirty, setFieldValue, values, errors, setFieldError, resetForm } = formikProps;
          return <>
            <Form className="form-wrapper">
              <VendorPricingModal
                closeModal={closeAddModal}
                vendorLocationList={vendorLocationList}
                setFieldValue={setFieldValue}
                formikValues={values}
                errors={errors}
                resetForm={resetForm}
                pageType='addMoreVendor'
                addMoreSelectedItem={addMoreSelectedItem}
              />
            </Form>
          </>
        }}
      </Formik>
    </>
  )
}

export default AddMoreVendorsToCustomerForm
